import { useEffect, useState } from "react";
import { supabase } from "services/supabaseClient";
import { useProfile } from "context/ProfileContext";

export default function useSmartDocAccess(orgId, featureKey = "fund-planner.smartdoc-import") {
  const { profile } = useProfile();
  const [state, setState] = useState({ loading: true, enabled: false });
  useEffect(() => {
    let active = true;
    if (!profile?.id || !orgId) { setState({ loading: false, enabled: false }); return () => { active = false; }; }
    if (profile.is_admin) { setState({ loading: false, enabled: true }); return () => { active = false; }; }
    setState((current) => ({ ...current, loading: true }));
    supabase.from("org_user_feature_access").select("feature_key").eq("user_id", profile.id).eq("org_id", orgId).eq("feature_key", featureKey).maybeSingle()
      .then(({ data, error }) => { if (active) setState({ loading: false, enabled: !error && !!data }); });
    return () => { active = false; };
  }, [featureKey, orgId, profile?.id, profile?.is_admin]);
  return state;
}
